export default {
  init() {

    if (!document.querySelector('.configurator')) {
      return;
    }

    const originalPrice = document.querySelector('.configurator  .woocommerce-Price-amount').innerText;

    document.querySelectorAll('.exp-image-checkbox').forEach((checkbox) => {
      const animationContainer = checkbox.querySelector('.configurator__animation');

      if (!animationContainer) {
        return;
      }

      const animationData = JSON.parse(animationContainer.getAttribute('data-lottie'));

      const animation = lottie.loadAnimation({
        container: animationContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: animationData,
      });

      checkbox.addEventListener('mouseenter', () => {
        animation.setDirection(1); // Play forward
        animation.play();
      });

      checkbox.addEventListener('mouseleave', () => {
        animation.setDirection(-1); // Reverse animation
        animation.play();
      });
    });

    document.querySelector('.configurator__reset').addEventListener('click', function () {

      document.querySelector('form.variations_form').reset();

      document.querySelectorAll('.configurator input').forEach(input => {

        if (input.type === 'checkbox') {
          input.checked = false;
          return;
        }

        if (input.type === 'radio') {
          document.querySelectorAll(`input[name="${input.name}"]`).forEach(radio => {
            radio.checked = false;
          });
        }

        document.querySelector('.configurator .woocommerce-Price-amount').innerHTML = '<bdi>' + originalPrice + '</bdi>';
      });

      document.querySelectorAll('.configurator select').forEach(select => {
        select.selectedIndex = 0;
        select.dispatchEvent(new Event('change'));
      })

      document.querySelectorAll('.checkbox.is-checked').forEach(checkbox => {
        checkbox.classList.remove('is-checked');
        checkbox.querySelector('input').checked = false;
      })

      document.querySelectorAll('.radio.is-checked').forEach(checkbox => {
        checkbox.classList.remove('is-checked');
        checkbox.querySelector('input').checked = false;
      })

    });

    document.querySelectorAll('.configurator-open').forEach(button => {
      button.addEventListener('click', function () {
        document.querySelector('.configurator').classList.add('configurator--active');
      });
    });

    let quantityAndPrice = document.querySelector('.express-quantity-and-price');
    let configuratorFooter = document.querySelector('.configurator__footer');

    if (quantityAndPrice && configuratorFooter) {
      configuratorFooter.appendChild(quantityAndPrice);
    }

    let checkBoxes = document.querySelectorAll('.exp-image-checkbox, .exp-colour-checkbox, .exp-radio-checkbox');

    checkBoxes.forEach(checkBox => {
      checkBox.addEventListener('click', function () {
        checkBox.querySelector('input').click();
      });
    });

    const configuratorSwitch = document.querySelector('.configurator__switch');

    if (configuratorSwitch) {
      configuratorSwitch.addEventListener('click', function () {
        this.classList.toggle('configurator__switch--active');
        document.querySelector('.configurator__gallery-items').classList.toggle('configurator__gallery-items--active');
      });
    }

    document.querySelector('.configurator__gallery-close').addEventListener('click', function () {
      document.querySelector('.configurator').classList.remove('configurator--active');
    });

    if (window.innerWidth < 1024) {
      this.initSlider();
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth < 1024) {
        this.initSlider();
      } else {
        $('.configurator__gallery-items').slick('unslick');
      }
    });

    const extraOptions = document.querySelector('.extra-options');
    const extraOptionsModal = document.getElementById('modal-pa_extra-options');

    if (extraOptions) {
      if (extraOptions.querySelectorAll('tr').length > 1) {
        const title = document.createElement('div');
        title.className = 'label';

        // Create the label content based on whether the modal exists
        if (extraOptionsModal) {
          title.innerHTML = '<label for="pa_threshold" style="display: flex;">EXTRA OPTIONS <a href="#modal-pa_extra-options" class="extra-tooltip js-popup-modal tooltip-bubble" style="margin-left: 10px; margin-top: 2px;"></a></label>';
        } else {
          title.innerHTML = '<label for="pa_threshold" style="display: flex;">EXTRA OPTIONS</label>';
        }

        extraOptions.insertAdjacentElement('beforebegin', title);
      }
    }

  },

  initSlider() {
    $('.configurator__gallery-items').slick({
      infinite: false,
      dots: true,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 569,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      }],
    });

    $('.configurator__gallery-items').on('afterChange', function () {
      $(document).trigger('lazyrefresh');
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/components/configurator.js